import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    astilleroURL: 'https://astillero.xcosoft.com',
    googleAPIKey: null,
    twilioSID: null,
    twilioNumber: null,
    twilioToken: null,
    user: {},
    token: null,
    isLogin: false,
    apiKey: 'AIzaSyDH7M1P0_vFz1ioc4QNxu25qpN0b-XoYRc',
    client: {},
    address: {},
    selected_client_nid: null,
    selected_address_nid: null,
    dialog_pedido: false,
    selecedClient: null,
    selectedAddress: null,
    orderType: 'Domicilio',
    selectedProducts: [],
    totalOrder: 0
  },
  getters: {
    getGoogleAPIKey(state) {
      return state.googleAPIKey
    },
    getTwilioSID(state) {
      return state.twilioSID
    },
    getTwilioNumber(state) {
      return state.twilioNumber
    },
    getTwilioToken(state) {
      return state.twilioToken
    },
    getCurrentUser(state) {
      return state.user
    },
    getPedidoDialog(state) {
      return state.dialog_pedido
    },
    getSelectedClient(state) {
      return state.selecedClient
    },
    getSelectedAddress(state) {
      return state.selectedAddress
    },
    getOrderType(state) {
      return state.orderType
    },
    getSelectedProducts(state) {
      return state.selectedProducts
    },
    getTotalOrder(state) {
      return state.totalOrder
    }
  },
  mutations: {
    setGoogleAPIKey(state, data) {
      state.googleAPIKey = data
    },
    setTwilioSID(state, data) {
      state.twilioSID = data
    },
    setTwilioNumber(state, data) {
      state.twilioNumber = data
    },
    setTwilioToken(state, data) {
      state.twilioToken = data
    },
    setSelecedClient(state, data) {
      state.selecedClient = data
      console.log('Selected Client', data)
    },
    setSelectedAddress(state, data) {
      state.selectedAddress = data
      console.log('Selected Address', data)
    },
    setSelectedProducts(state, data) {
      state.selectedProducts.push(data)
      state.totalOrder += Number(data.precio)
      console.log('Selected Products',  state.selectedProducts)
      console.log('Total',  state.totalOrder)
    },
    removeProduct(state, currentIndex) {
      state.selectedProducts = state.selectedProducts.filter((i, index) => index != currentIndex)
      console.log('Selected Products',  state.selectedProducts)
    },
    updatePrice(state, price) {
      state.totalOrder = state.totalOrder - price
      console.log("Total", state.totalOrder)
    },
    resetOrder(state) {
      state.selecedClient = null
      state.selectedAddress = null
      state.orderType = null
      state.selectedProducts = []
      state.totalOrder = 0
      state.dialog_pedido = false
    },
    setClient(state, nid) {
      state.selected_client_nid = nid
    },
    setAddress(state, nid) {
      state.selected_address_nid = nid
    },
    openPedidoDialog(state) {
      state.dialog_pedido = true
    },
    closePedidoDialog(state) {
      state.dialog_pedido = false
    },
    setOrderType(state, type) {
      state.orderType = type
      console.log('Tipo de Orden', type)
    }
  },
  actions: {
  },
  modules: {
  }
})
